exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chartjs-render-monitor[data-v-ea148fda] {\n    width: 1000px !important;\n}\n\n", ""]);

// exports
